const REGEXPS = {
  SAFE_ID: /[^a-z0-9$_]/g,
  SPLIT_ID: /(?:]\[?|\[)/g
};

module.exports = {
  hydrate (id) {
    if (id && id.includes('[') && id.includes(']'))
      id = id.split(REGEXPS.SPLIT_ID).slice(0, -1);
    return id;
  },
  idstr (id) {
    return Array.isArray(id) ? id[0] + '[' + id.slice(1).join('][') + ']' : id;
  },
  idzero (id) {
    return Array.isArray(id) ? id[0] : id;
  },
  safeid (id) {
    id = id || '';
    id = Array.isArray(id) ? id[0] : ('' + id).trim().toLowerCase();
    return 'chi_' + id.replace(REGEXPS.SAFE_ID, '_');
  }
};
